import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function InfoCircle({ width = 18, height = 18, fill = '#6AA6F6' }: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99935 0.666992C4.39935 0.666992 0.666016 4.40033 0.666016 9.00033C0.666016 13.6003 4.39935 17.3337 8.99935 17.3337C13.5993 17.3337 17.3327 13.6003 17.3327 9.00033C17.3327 4.40033 13.5993 0.666992 8.99935 0.666992ZM8.99935 13.167C8.54102 13.167 8.16602 12.792 8.16602 12.3337V9.00033C8.16602 8.54199 8.54102 8.16699 8.99935 8.16699C9.45768 8.16699 9.83268 8.54199 9.83268 9.00033V12.3337C9.83268 12.792 9.45768 13.167 8.99935 13.167ZM9.83268 6.50033H8.16602V4.83366H9.83268V6.50033Z"
        fill={fill}
      />
    </Svg>
  );
}
